<template>
  <SGPDrawerComponent 
    :loading="!camposFiltrosComputed.length"  
    @input="mudancaStatus" 
    v-model="abrirFiltroAvancado"
    class="pt-15"
    width="400"
    fixed
  >

<SGPFiltroComponent>  
  <template v-slot:form>
    <SGPFormFilterComponent
      v-if="camposFiltrosComputed.length"
      :key="versaoForm"
      :campos="camposFiltrosComputed"
      @sgpFormFilterDadosClick="emitirAplicarFiltro"
      @sgpFormFilterLimpar="limparFormFilter"
    > 
    </SGPFormFilterComponent>
  </template>
</SGPFiltroComponent>  
</SGPDrawerComponent>
</template>

<script>
import { mapActions,mapGetters } from 'vuex'
import { centroFuncionalOpcoes } from '@/common/helpers/centroFuncional'
import { CTRL_MODULOS } from '@/common/boot/Constantes'

export default {
  name: 'SGPFiltroAvancadoComponent',
  props: {
    abrirFiltroAvancado: {
      type: Boolean,
      required: true
    },
    comFiltroOs: {
      type: Boolean,
      default: false
    },
    comCentroFuncional: {
      type: Boolean,
      default: false
    },
    filtroPainel: {
      type: Boolean,
      default: false
    },
    comFiltroProvedorNome: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      filtroPayload: {},
      versaoForm: 0,
    }
  },

  async created () {
    this.limparFiltroLocalStorage()
  },

  async mounted () {
    if (this.filtroPainel) {
      this.listarProvedores()
      this.listarFiltrosPainelBacklog()
      return
    }

    this.listarProvedores()
    this.listarCtrlEstados()
    this.listarTiposSolicitacao()
    this.listarTiposServico()
    this.listarRegionaisPermitidas()
  },
  
  computed: {
    ...mapGetters('ctrlProvedores', ['listaDeProvedores']),
    ...mapGetters('ctrlEstadosWf', ['listaDeCtrlEstados']),
    ...mapGetters('ctrlTipoSolicitacao', ['listaDeTiposSolicitacao']),
    ...mapGetters('ctrlTipoServico', ['listaDeTiposServico']),
    ...mapGetters('ctrlRegionais', ['listaDeRegionais']),
    ...mapGetters('backlog', ['filtrosPainelBacklog']),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),

    camposFiltrosComputed () {
      if (this.filtroPainel) {
        return this.camposFiltroPainel()
      }

      const campos = []

      if (this.listaDeProvedores.length &&
          this.listaDeCtrlEstados.length &&
          this.listaDeTiposSolicitacao.length &&
          this.listaDeTiposServico.length &&
          this.listaDeRegionais.length
      ) {
        campos.push({
          name: 'ctrl_provedor_id',
          value: this.filtroPayload.ctrl_provedor_id ? this.filtroPayload.ctrl_provedor_id : null,
          titulo: 'Provedor',          
          type: 'auto_complete',
          class: 'text-uppercase',
          options: this.listaDeProvedores.map(item => {
            return { value: item.id, text: item.nome }
          })
        })

        if (this.comCentroFuncional) {
          campos.push({
            name: 'centro_funcional',
            value: this.filtroPayload.centro_funcional || null,
            titulo: 'Centro Funcional',
            type: 'unico',
            options: centroFuncionalOpcoes,
          })
        }

        campos.push({
          name: 'data_abertura',
          value: this.filtroPayload.data_abertura ? this.filtroPayload.data_abertura : null,
          titulo: 'Data abertura',
          type: 'date',
          time: false
        })

        campos.push({
          name: 'data_fechamento',
          value: this.filtroPayload.data_fechamento ? this.filtroPayload.data_fechamento : null,
          titulo: 'Data fechamento',
          type: 'date',
          time: false
        })

        campos.push({
          name: 'ctrl_estado_provedor_id',
          value: this.filtroPayload.ctrl_estado_provedor_id ? this.filtroPayload.ctrl_estado_provedor_id : null,
          titulo: 'UF',          
          type: 'auto_complete',
          class: 'text-uppercase',
          options: this.listaDeCtrlEstados.map(item => {
            return { value: item.id, text: item.uf }
          })
        })

        campos.push({
          name: 'ctrl_tipo_solicitacao_id',
          value: this.filtroPayload.ctrl_tipo_solicitacao_id ? this.filtroPayload.ctrl_tipo_solicitacao_id : null,
          titulo: 'Tipo de Solicitação',
          valueLabel: '',
          type: 'unico',
          options: this.listaDeTiposSolicitacao.map(item => {
            return { value: item.id, text: item.nome }
          })
        })

        campos.push({
          name: 'ctrl_tipo_servico_id',
          value: this.filtroPayload.ctrl_tipo_servico_id ? this.filtroPayload.ctrl_tipo_servico_id : null,
          titulo: 'Tipo de Serviço',
          valueLabel: '',
          type: 'unico',
          options: this.listaDeTiposServico.map(item => {
            return { value: item.id, text: item.nome }
          })
        })

        campos.push({
          name: 'ctrl_regional_id',
          value: this.filtroPayload.ctrl_regional_id ? this.filtroPayload.ctrl_regional_id : null,
          titulo: 'Regional',
          valueLabel: '',
          type: 'unico',
          options: this.listaDeRegionais.map(item => {
            return { value: item.id, text: item.regional }
          })
        })

        campos.push({
          name: 'cod_circuito',
          value: this.filtroPayload.cod_circuito ? this.filtroPayload.cod_circuito : null,
          titulo: 'Circuito',
          valueLabel: '',
          type: 'text',
        })

        if (this.comFiltroOs) {
          campos.push({
            name: 'os',
            value: this.filtroPayload.os ? this.filtroPayload.os : null,
            titulo: 'OS',
            valueLabel: '',
            type: 'text',
          })
        }
      }
      return campos
    }
  },

  methods: {
    ...mapActions('ctrlProvedores', ['listarProvedores']),
    ...mapActions('ctrlEstadosWf', ['listarCtrlEstados']),
    ...mapActions('ctrlTipoSolicitacao', ['listarTiposSolicitacao']),
    ...mapActions('ctrlTipoServico', ['listarTiposServico']),
    ...mapActions('ctrlRegionais', ['listarRegionaisPermitidas']),
    ...mapActions('backlog', ['listarFiltrosPainelBacklog']),

    camposFiltroPainel() {
      const campos = []

      if (this.comFiltroProvedorNome) {
        campos.push({
          name: 'ctrl_provedor_id',
          value: this.filtroPayload.ctrl_provedor_id || null,
          titulo: 'Provedor',
          type: 'unico',
          options: (Array.isArray(this.listaDeProvedores) ? this.listaDeProvedores : [])
            .filter(item => item?.id != null && item?.nome)
            .map(item => ({ value: item.id, text: item.nome })),
        })
      }

      if (this.comCentroFuncional) {
        campos.push({
          name: 'centro_funcional',
          value: this.filtroPayload.centro_funcional || null,
          titulo: 'Centro Funcional',
          type: 'unico',
          options: centroFuncionalOpcoes,
        })
      }

      this.adicionarFiltrosLocalizacao(campos)

      campos.push(
        {
          name: 'periodo',
          value: this.filtroPayload.periodo || '',
          titulo: 'Período',
          type: 'mes',
        },
        {
          name: 'user_tratamento_id',
          value: Boolean(this.filtroPayload.user_tratamento_id),
          titulo: 'Minhas Tarefas',
          type: 'toggle',
        },
        {
          name: 'interrupcoes',
          value: Boolean(this.filtroPayload.interrupcoes),
          titulo: 'Agendamentos',
          type: 'toggle',
        },
      )

      return campos
    },

    adicionarFiltrosLocalizacao(campos) {
      const dados = this.filtrosPainelBacklog || {}
      const regionais = Array.isArray(dados.regionais) ? dados.regionais : []

      if (this.moduloAtivo == CTRL_MODULOS.RECUPERACAO) {
        campos.push({
          name: 'uf_ponta_a',
          value: this.filtroPayload.uf_ponta_a || null,
          titulo: 'UF',
          type: 'unico',
          options: (Array.isArray(dados.ufs) ? dados.ufs : []).map(uf => ({ value: uf, text: uf })),
        })
        campos.push({
          name: 'regional_sigla',
          value: this.filtroPayload.regional_sigla || null,
          titulo: 'Regional',
          type: 'unico',
          options: regionais.map(item => ({ value: item.sigla, text: item.nome })),
        })
        return
      }

      if (this.moduloAtivo == CTRL_MODULOS.INSTALACAO) {
        campos.push({
          name: 'ctrl_regional_id',
          value: this.filtroPayload.ctrl_regional_id || null,
          titulo: 'Regional',
          type: 'unico',
          options: regionais.map(item => ({ value: item.id, text: item.regional })),
        })
      }
    },

    mudancaStatus(val) {
      this.$emit('mudancaStatusEmit', val);
    },

    emitirAplicarFiltro(dados) {
      const valueInit = {}
      dados = {
        ...dados.reduce((obj, item) => {
          return {...obj, [item.name]: item.value }
        }, valueInit)
      };

      this.$emit('sgpFormFilterDadosClick', dados)
    },

    limparFormFilter() {
      this.filtroPayload = {}
      this.versaoForm += 1
      this.limparFiltroLocalStorage()
      this.$emit('limparDadosEmit')
    },
    limparFiltroLocalStorage () {      
      if(localStorage.filtroAvancado) {
        localStorage.removeItem('filtroAvancado')
      }
    },
  },

  watch: {
    moduloAtivo() {
      if (this.filtroPainel) this.listarFiltrosPainelBacklog()
    },
    filtrosPainelBacklog() {
      if (this.filtroPainel) this.versaoForm += 1
    },
  },

  beforeDestroy () {
    this.camposFiltrosComputed = []
  },

}
</script>
